import { render, staticRenderFns } from "./assign-to-supplier-dialog.vue?vue&type=template&id=988e360e&"
import script from "./assign-to-supplier-dialog.vue?vue&type=script&lang=js&"
export * from "./assign-to-supplier-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports